import { gql } from "@apollo/client";

export const ConfirmForgotPassword = gql`
  mutation ConfirmForgotPassword(
    $username: String!
    $email: String!
    $code: String!
    $newPassword: String!
    $region: AWSRegions!
  ) {
    confirmForgotPassword(
      username: $username
      email: $email
      code: $code
      newPassword: $newPassword
      region: $region
    ) {
      message
    }
  }
`;
